/*============================================================================
  #Homepage Videos -- EL-section-image-with-text                 EdLandis.Dev
==============================================================================*/

document.addEventListener('DOMContentLoaded', function () {

    var target = document.querySelector('[class*=el_section_multi_column_images]');

    var interObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {

                document.querySelectorAll('.EL-section-image-with-text .hp-video').forEach(function(btn) {

                    var parent = btn.closest('.hp-video');
                    var vimeoVideo = parent.querySelector('.vimeo-video');

                    var vimeoPlayer = new Vimeo.Player(vimeoVideo);

                    btn.addEventListener('click', function() {
                        if (!parent) return;

                        var preview = parent.querySelector('.video-preview');
                        if (preview) preview.style.display = 'none';

                        var vimeoVideo = parent.querySelector('.vimeo-video');
                        if (vimeoVideo) {
                            vimeoVideo.style.display = 'block';

                            try {
                                vimeoPlayer.play();
                            } catch (err) {
                                vimeoVideo.contentWindow.postMessage('{"method":"play"}', '*');
                            }
                        }
                    });
                });
                
                // Optional: Stop observing if you only need the event to fire once
                interObserver.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.5 // Triggers when 50% of the element is visible
    });
    // 3. Start observing the target
    interObserver.observe(target);

    var vimeoVideos = document.getElementsByClassName('vimeo-video');
    Array.from(vimeoVideos).forEach(function(video) {
        if (video.tagName === 'IFRAME') {
            var player = new Vimeo.Player(video);
            player.setVolume(0.4).catch(function(error) {
            console.error('Vimeo volume could not be set:', error.name);
            });
        // This else conditional is actually for the FSLP primer page
        } else if (video.tagName === 'VIDEO') {
            try {
                video.volume = 0.3;
            } catch (e) {
                console.error('HTML5 video volume could not be set:', e);
            }
        }
    });
});
